import React from "react";
import { Link } from "react-router-dom";
import isEmpty from "lodash.isempty";

export default ({ promotionTypes, onClickDelete }) => {
  const TableOrNotFound = () => {
    if (promotionTypes.loading) {
      return "is Loading";
    }
    if (isEmpty(promotionTypes.data)) {
      return (
        <p className="is-size-2 has-text-centered has-text-grey">
          Found Nothing
        </p>
      );
    }
    return (
      <table className="table is-fullwidth is-striped is-hoverable">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Configuration</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {promotionTypes.data.map((promotionType) => (
            <tr key={promotionType.id}>
              <td>
                <a>{promotionType.id}</a>
              </td>
              <td>
                <a>{promotionType.name}</a>
              </td>
              <td>{promotionType.conf}</td>

              <td className="is-icon">
                <p className="buttons">
                  <Link
                    to={`/promotion-types/${promotionType.id}/edit`}
                    className="button  is-link is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-edit" />
                    </span>
                    <span>Edit</span>
                  </Link>
                  <a
                    onClick={onClickDelete(promotionType.id)}
                    to={`/promotion-types/${promotionType.id}/delete`}
                    className="button is-danger is-small"
                  >
                    <span className="icon">
                      <i className="fas fa-trash" />
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };
  return (
    <section className="section">
      <TableOrNotFound />
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/pages/PromotionType/Index/Table.js